import React, { useEffect, useState } from "react"
import { Input, Label } from "../../components/Form"
import { Button } from "../../components/Button"
import ESMFormulaCompiler from "../../core/esm"
import { AiFillCaretDown } from "react-icons/ai"
import GPTModal from "../../container/GPTModal"
import { ActionGrid } from "../../components/List"
import ModalAlert from "../../components/ModalAlert"
import { EscalaLabel2 } from "../../components/EscaleBar"
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import { sort } from "fast-sort"
import { HeaderCard} from "../../components/Header"

import "./styles.scss"


const IndicatorDetailsScreen = ({
  isUpdate,
  values,
  actionList,
  odsArea,
  setValues,
  onSaveIndicator,
  removeIndicator,
  onUpdateIndicator,
  onBack,
  onSaveActions,
  setCopyRows,
  onSelectedRowsChange,
  selectedRows,
  removeAction,
  showOnlyActions,
  showModalActions,
  goBack,
  handleReloadActions,
  projects,
  handleChangeProject 
}) => {

  const onRemoveIndicator = (isUpdate) => {
    return isUpdate
      ? ModalAlert.danger({
          title: "Deseja Remover?",
          confirmLabel: "Ok",
          onConfirm: () => removeIndicator(),
        })
      : onBack()
  }

  return (
    <div className="indicator-details-container">
      {!showOnlyActions && (
        <div className="indicator-details-screen">
          <HeaderCard title={isUpdate ? "Detalhes do indicador" : "Cadastrar Indicador"} {...{ goBack }} styles={{padding: 0}}/>
          <Label label={"Título do indicador"} />
          <Input
            value={values.title || ""}
            placeholder="Insira o título do indicador"
            onChange={(e) => setValues((values) => ({ ...values, title: e.target.value }))}
          />
            <div className="form-box">
              <div>
                <Label label={"Categoria"} />
                <Input
                  value={values.category || ""}
                  placeholder="Insira a categoria"
                  onChange={(e) => setValues((values) => ({ ...values, category: e.target.value }))}
                />
              </div>
              <div>
                <Label label="Peso do indicador" />
                <Input
                  type={"number"}
                  value={values?.weight || 1}
                  placeholder="Peso"
                  onChange={(e) => setValues((values) => ({ ...values, weight: e.target.value }))}
                />
              </div>
            </div>
          <div className="horizontal-row">
            <div className="escala-indicator-container">
              <Label label={"Escala"} />
              <Escala min={values.min} max={values.max} />
            </div>
          </div>
          <Label label={"Código do indicador"} />
          <CodeMirror
            value={values.formula || ""}
            height="200px"
            extensions={[javascript({ jsx: true })]}
            onChange={(code) => setValues(values => ({ ...values, formula: code }))}
          />
            <Label label={"Calculadora para validação"} />
            <FormulaCalculator formula={values.formula || ""} max={values.max} min={values.min} />
            <br />
            <br />
            <div className="indicator-details-buttons">
              <Button
                label={isUpdate ? "Excluir" : "Cancelar"}
                color="orange"
                handleClick={() => onRemoveIndicator(isUpdate)}
              />
              <Button
                label={isUpdate ? "Atualizar Indicador" : "Salvar Indicador"}
                handleClick={() => (isUpdate ? onUpdateIndicator() : onSaveIndicator())}
              />
            </div>
        </div>
      )}
      {isUpdate && (
        <div className="indicator-details-screen">
          <HeaderCard title={isUpdate ? "Detalhes do indicador" : "Cadastrar Indicador"} styles={{padding: 0}}>
          <GPTModal
            title="Recomendações"
            onSaveActions={onSaveActions}
            actions={actionList || []}
            odsArea={odsArea}
            projects={projects}
            values={values}
            handleChangeProject={handleChangeProject}
          />
          </HeaderCard>
          <ActionGrid
            rows={Array.isArray(actionList) ?  sort(actionList).desc(a => a.createdAt).map((item) => ({ ...item, edit: true })) : []}
            checkbox={false}
            isEditable={true}
            setCopyRows={setCopyRows}
            showOnlyActions={true}
            isDeletable={true}
            onSelectedRowsChange={onSelectedRowsChange}
            removeAction={removeAction}
            odsArea={odsArea}
            hasActionsDetails
            handleReloadActions={handleReloadActions}
          />
        </div>
      )}
      {showModalActions && (
        <GPTModal
          title="Ações"
          onSaveActions={onSaveActions}
          actions={actionList || []}
          odsArea={odsArea}
          projects={projects}
          values={values}
          {...{ showModalActions, setShowModalActions, selectedRows }}
        />
      )}
    </div>
  )
}

export const Escala = ({ min: strMin, max: strMax, value: strValue }) => {
  const min = parseFloat(strMin)
  const max = parseFloat(strMax)
  const value = parseFloat(strValue) || 0

  const div = (max - min) / 5

  const distance = (max - min) / 100

  const indicatorValor = distance * value

  return (
    <EscalaLabel2
      e5={parseFloat(max).toFixed(2)}
      e4={parseFloat(min + div * 4).toFixed(2)}
      e3={parseFloat(min + div * 3).toFixed(2)}
      e2={parseFloat(min + div * 2).toFixed(2)}
      e1={parseFloat(min + div * 1).toFixed(2)}
      e0={parseFloat(min).toFixed(2)}>
      {indicatorValor.length > 0 && (
        <div className="indicator" style={{ left: `calc(${indicatorValor}% - 15px)` }}>
          <AiFillCaretDown />
        </div>
      )}
    </EscalaLabel2>
  )
}

export const FormulaCalculator = ({ formula, max, min }) => {
  const [values, setValues] = useState({})
  const [variables, setVariables] = useState([])
  const [value, setValue] = useState()

  useEffect(() => {
    let matches = extractVariables(formula)
    setVariables(matches)
  }, [formula])

  const calculate = () => {
    const dados = variables.map((Pergunta_codigo) => ({
      Pergunta_codigo,
      Escala: parseFloat(values[Pergunta_codigo]),
    }))

    console.log({ dados })

    if (dados.find((item) => item.Escala === undefined || isNaN(item.Escala))) {
      alert("Valores inválidos")
      return
    }

    const esmFormula = new ESMFormulaCompiler(dados)

    const value = esmFormula.getValue(formula)

    setValue(value)
  }

  return (
    <div className="calculator-container">
      <div className="caculator-box">
        {variables.map((item) => (
          <div>
            <Label label={item} />
            <Input
              type={"number"}
              value={values[item]}
              placeholder="Insira um valor numérico"
              onChange={(e) => setValues((values) => ({ ...values, [item]: e.target.value }))}
            />
          </div>
        ))}
        <Button label={"Calcular"} handleClick={calculate} />
      </div>
      <div className="escala-conceito">
        {value && <div className="conceito">{value}</div>}
        <Escala max={max} min={min} value={value} />
      </div>
    </div>
  )
}

export const extractVariables = (indice) => {
  const regex = /#(.*?)\)/g
  let matches = []
  let match = regex.exec(indice)

  while (match != null) {
    matches.push(match[1])
    match = regex.exec(indice)
  }

  return [...new Set(matches || [])] // ["NUMDEMORADORES", "COMODOS"]
}

export default IndicatorDetailsScreen
